const BASE = process.env.REACT_APP_SOUNDSTATS_API_URL || 'https://api.lyveaia.com';
const CLIENT_ID = process.env.REACT_APP_SOUNDCHARTS_CLIENT_ID;
const CLIENT_SECRET = process.env.REACT_APP_SOUNDCHARTS_CLIENT_SECRET;

function headers() {
  return {
    accept: '*/*',
    'X-SC-Client-Id': CLIENT_ID || '',
    'X-SC-Client-Secret': CLIENT_SECRET || '',
  };
}

async function getJson(path) {
  const r = await fetch(`${BASE}${path}`, { headers: headers() });
  if (!r.ok) {
    const text = await r.text();
    throw new Error(`Soundstats ${r.status}: ${text.slice(0, 220)}`);
  }
  return r.json();
}

function mapArtist(a) {
  if (!a) return null;
  return {
    uuid: a.uuid || '',
    slug: a.slug || '',
    name: a.name || '—',
    appUrl: a.appUrl || '',
    imageUrl: a.imageUrl || '',
    webUrl: a.webUrl || '',
    countryCode: a.countryCode || '',
    careerStage: a.careerStage || '',
    growthLevel: a.growthLevel || '',
    genre: a.genres && a.genres[0] ? a.genres[0].root : '',
    isni: a.isni || '',
  };
}

const soundstatsService = {
  async searchArtist(term, options = {}) {
    const q = String(term || '').trim();
    if (!q) return { artists: [], total: 0 };
    const offset = Math.min(Math.max(Number(options.offset) || 0, 0), 50);
    const limit = Math.min(Math.max(Number(options.limit) || 8, 1), 50);
    const json = await getJson(
      `/soundstats/search/artist/${encodeURIComponent(q)}?offset=${offset}&limit=${limit}`,
    );
    const raw = Array.isArray(json.items) ? json.items : Array.isArray(json.results) ? json.results : [];
    const artists = raw.map(mapArtist).filter(Boolean);
    return { artists, total: json.total || artists.length, source: 'Soundcharts' };
  },

  async getArtistGroups(uuid) {
    const json = await getJson(`/soundstats/artist/${encodeURIComponent(uuid)}/groups`);
    return json;
  },

  async getArtistIntelligence(uuid, group) {
    const json = await getJson(
      `/soundstats/artist/${encodeURIComponent(uuid)}/intelligence/${encodeURIComponent(group)}`,
    );
    return json;
  },
};

export default soundstatsService;
